import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'classnames';
import { prop } from 'ramda';
import styles from './styles.module.scss';
import { RemoveUserAction } from './remove-user-action';
import { WalkInNotes } from './walk-in-notes';
import { InviteTimerAction } from './invite-timer-action';
import ReorderIcon from '../icons/reorder.svg';
export var Reorder = function (_a) {
    var canReorder = _a.canReorder;
    if (!canReorder) {
        return null;
    }
    return (_jsx("div", { className: "".concat(styles['icon-btn'], " ").concat(styles['drag-handle']), children: _jsx(ReorderIcon, {}) }));
};
export var Order = function (_a) {
    var value = _a.value;
    return _jsx("div", { className: styles.order, children: value });
};
export var SecondaryLabel = function (_a) {
    var children = _a.children;
    return _jsx("div", { className: styles['secondary-label'], children: children });
};
export var Actions = function (props) {
    return (_jsxs("div", { className: styles.actions, children: [_jsx(RemoveUserAction, { recordId: props.recordId, clientName: props.clientName }), _jsx(InviteTimerAction, { countdownTo: props.countdownTo }), !props.countdownTo && _jsx(WalkInNotes, { appointmentNote: props.appointmentNote, customerNote: props.customerNote })] }));
};
Actions.defaultProps = {
    countdownTo: null,
    appointmentNote: null,
    customerNote: null,
};
export var Status = function (props) {
    var _a;
    var isPositive = props.status === 'accepted';
    return _jsx("div", { className: cx(styles.status, (_a = {}, _a[styles['status--positive']] = isPositive, _a)), children: props.status });
};
export var Services = function (props) { return (_jsx(SecondaryLabel, { children: props.services.map(prop('name')).join(', ') })); };
